// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyBVMKvMcA22ByCqiKo_69Gq3ziSJrLM0iM',
    authDomain: 'noxeo-16277.firebaseapp.com',
    databaseURL: 'https://noxeo-16277.firebaseio.com',
    projectId: 'noxeo-16277',
    storageBucket: 'gs://noxeo-16277.appspot.com',
    messagingSenderId: '583259711717'
  }
};



// WEBPACK FOOTER //
// /Users/Mustafa/Developpement/noxoe/src/environments/environment.ts